<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="otp">Код из СМС</label>
    <input
      type="text"
      class="form-control"
      id="otp"
      placeholder="Введите код из СМС"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'otp-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Otp.vue?3a6cf5e3